module.exports = __webpack_public_path__ + "static/media/18ECA13.8642975b.jpg";